<template>
  <button
    type="button"
    aria-label="Close"
    class="absolute top-2 right-2 z-20 hidden size-[22px] cursor-pointer items-center justify-center rounded-[6px] text-gray-500/50 transition hover:bg-gray-200/25 hover:text-gray-500 tablet-v:flex"
    :disabled="busy"
    @click="emit('close')"
  >
    <CloseIcon class="size-[13px]" aria-hidden="true" />
  </button>

  <div class="relative z-10 flex h-7 items-center pb-1">
    <button
      v-if="back"
      type="button"
      aria-label="Back"
      class="flex size-[26px] shrink-0 cursor-pointer items-center justify-center rounded-[6px] text-gray-800 transition hover:bg-gray-200/50 disabled:pointer-events-none"
      :class="centered ? 'absolute -left-[5px]' : 'mr-1.5 -ml-[5px]'"
      :disabled="busy"
      @click="emit('back')"
    >
      <ChevronLeftIcon class="size-5" aria-hidden="true" />
    </button>
    <h2
      class="flex-1 truncate text-[17px] leading-6 font-medium text-gray-800"
      :class="centered ? 'px-8 text-center' : 'text-left'"
    >
      {{ title }}
    </h2>
  </div>
</template>

<script setup lang="ts">
import { ChevronLeftIcon, CloseIcon } from '@dacr/icons'

defineProps<{
  title: string
  back?: boolean
  centered?: boolean
  busy?: boolean
}>()

const emit = defineEmits<{ back: []; close: [] }>()
</script>
